import { useLocation } from 'react-router-dom';

const FALLBACKS = [
    { match: '/profile', label: 'پروفایل' },
    { match: '/releases', label: 'نسخه‌های جدید' },
];

function findActiveItem(pathname, items, buildHref) {
    let best = null;
    for (const item of items) {
        const href = buildHref(item);
        const exact = pathname === href;
        const nested = !item.end && pathname.startsWith(href + '/');
        if (!exact && !nested) continue;
        if (!best || href.length > buildHref(best).length) {
            best = item;
        }
    }
    return best;
}

export function usePageTitle(items, buildHref) {
    const location = useLocation();
    const active = findActiveItem(location.pathname, items, buildHref);
    if (active) return active.label;
    const fallback = FALLBACKS.find(({ match }) => location.pathname.includes(match));
    return fallback?.label || '';
}

export default usePageTitle;
